import React, {Fragment} from "react";

import HookSubFormTransition from "root/Base/HookFormComponents/Education/HookSubFormTransition";
import HookSubFormRiskOfExclusion from "root/Base/HookFormComponents/Education/HookSubFormRiskOfExclusion";
import HookSubFormFullTimeEducation from "root/Base/HookFormComponents/Education/HookSubFormFullTimeEducation";
import HookSubFormReducedTimetable from "root/Base/HookFormComponents/Education/HookSubFormReducedTimetable";

import HookSubFormPost16EducationStatus from "root/Base/HookFormComponents/Education/HookSubFormPost16EducationStatus";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";
import {formModes} from "root/Base/HookFormComponents/childDataFormHelpers";
import {EducationStatusTypes} from "root/DataFunctions/Constants";
import HookSubFormNEETBursary from "root/Base/HookFormComponents/Education/HookSubFormNEETBursary";
import HookSubFormEETBursary from "root/Base/HookFormComponents/Education/HookSubFormEETBursary";

const HookFormGroupEducation = ({control, register, watch, formMode, isPost16, formErrors, readOnly, childYearGroup }) =>
{
    const controlProps = {
        control: control,
        register: register,
        watch: watch,
        formErrors: formErrors,
        readOnly: readOnly
    }

    const [ year_id ] = useWatchDropdown( {control, name: 'header.year_id' }) ;

    const NEETStatus = watch('post16' + '.education_status_id') ;

    const educationStatusType = NEETStatus === null ? null : NEETStatus.es_type ;

    const isNEET = educationStatusType === EducationStatusTypes.NEET ;

    const shouldShowPost16 = () =>
    {
        if ( formMode === formModes.CREATE )
        {
            // If we are in create mode, then we must determine the post16 status from the selected year
            return [12,13].includes(+year_id) === true ;
        }
        else
        {
            return isPost16 ;
        }
    }

    const shouldShowYear4 = () =>
    {
        return [4,5,6,7,8,9,10,11].includes(+year_id) === true ;
    }
    const isEarlyYears = () =>
    {
        // If we are in create mode, then we must determine the post16 status from the selected year
        return [14,15,17].includes(+year_id) === true ;
    }

    return (
        <Fragment>
            { shouldShowPost16() === true && <HookSubFormPost16EducationStatus { ...controlProps } sectionName='post16'/> }
            { shouldShowPost16() === false && <HookSubFormTransition { ...controlProps } sectionName='transition'/> }
            { shouldShowPost16() === false && <HookSubFormRiskOfExclusion { ...controlProps } sectionName='risk_of_exclusion'/> }
            { ( shouldShowPost16() === false && !isEarlyYears() === true ) && <HookSubFormFullTimeEducation { ...controlProps } sectionName='full_time_education'/> }
            { ( shouldShowPost16() === false && !isEarlyYears() === true ) && <HookSubFormReducedTimetable { ...controlProps } sectionName='reduced_timetable'/> }
            { /* shouldShowPost16() === false && <HookSubFormStarFunding { ...controlProps } sectionName='star_funding'/> */}
            { ( shouldShowPost16() === true && educationStatusType === EducationStatusTypes.NEET ) && <HookSubFormNEETBursary { ...controlProps } sectionName='employment'/> }
            { ( shouldShowPost16() === true && educationStatusType === EducationStatusTypes.EET ) && <HookSubFormEETBursary { ...controlProps } sectionName='eet_bursary'/> }
        </Fragment>
    )
}

export default HookFormGroupEducation ;